import { render, staticRenderFns } from "./shield.vue?vue&type=template&id=2fea0199&scoped=true&"
var script = {}
import style0 from "./shield.vue?vue&type=style&index=0&id=2fea0199&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea0199",
  null
  
)

export default component.exports